import React, { useEffect, useState, useContext } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar';
import { UserContext } from './UserContext';
import { useSelector, useDispatch } from 'react-redux';

const NewDashboard = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const { userData } = useContext(UserContext);
  const [prData, setPrData] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  //console.log(token); return false;
  const userId = localStorage.getItem('userId');
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  return (
    <>
      <Topbar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">Dashboard</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                  <li className="breadcrumb-item active">Dashboard</li>
                </ol>
              </div>
            </div>
          </div>
<div className="row g-0">
					<div className="col-lg-12 col-md-12">
						<div className="card border">
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="d-flex no-block align-items-center" style={{height: "300px"}}>
											<div>
												<h3 className="text-muted">Welcome, click on any link to navigate to the corresponding page..</h3>
											</div>
										</div>
									</div>
									<div className="col-12">
										<div className="progress">
											<div className="progress-bar bg-primary" role="progressbar" ></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
        </div>
      </div>
    </>
  );
};

export default NewDashboard;
